import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { UI } from 'components/index'
import { defaultValues } from './constants'
import { isProduction } from 'helpers/Utils'
import { toast } from 'react-toastify'
import { createOdooContact } from 'api/CRM'
import Form from './Form'
import Result from './Result'

const GlobalComplementario = () => {
  const [result, setResult] = useState('')
  const [showResults, setShowResults] = useState(false)
  const [loading, setLoading] = useState(false)

  const {
    watch,
    register,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues,
    mode: 'onBlur',
    // resolver: yupResolver(handleValidationResolver()),
  })

  const { ticketFees, firstname: name, email, phone } = watch()

  const handleAddContact = async () => {
    try {
      const payload = {
        name,
        email,
        phone,
        mobile: phone,
        x_campana: 'Simulador: Global complementario',
      }
      // Solo funcionará en prod y no debe llevar await para que no corte la ejecución
      isProduction() && createOdooContact(payload)
    } catch (error) {
      console.error('Error al agregar contacto:', error)
    }
  }

  // Simulación con la API, se envía el payload y setea el resultado
  const handleSubmit = async () => {
    setLoading(true)
    try {
      handleAddContact()
      setLoading(false)
      setShowResults(true)
      window.scrollTo(0, 0)
      return toast.success('Simulación exitosa')
    } catch (error) {
      console.error(error)
      setLoading(false)
      return toast.error('Error al simular, intente nuevamente')
    }
  }

  const resetSimulator = () => {
    setShowResults(false)
    reset(defaultValues)
    setResult('')
    window.scrollTo(0, 0)
  }

  // Validación de formulario básico
  const validate = Boolean(ticketFees && name && email && phone)

  return (
    <div className="flex flex-col my-6 space-y-6">
      <UI.Header
        title={showResults ? `Valor estimado impuesto a pagar:` : 'Impuesto Global complementario'}
        subtitle={!showResults && '¿Cuánto tengo que pagar?'}
        classNames={{
          title: `text-4xl font-extrabold text-secondary ${showResults && 'max-w-[340px] mx-auto'}`,
        }}
      />
      {!showResults && (
        <Form
          watch={watch}
          register={register}
          setValue={setValue}
          errors={errors}
          handleSubmit={handleSubmit}
          loading={loading}
          isDisabled={!validate}
          setResult={setResult}
        />
      )}
      {showResults && <Result result={result} resetSimulator={resetSimulator} />}
    </div>
  )
}

export default GlobalComplementario
